import React from "react";

import { useFeatureFlag } from "fond/featureFlags";

import InteractiveBomModal from "./InteractiveBom/InteractiveBomModal";
import BomModal from "./BomModal";
import { BomModalProps } from "./index";

const BomModalSwitch: React.FC<BomModalProps> = ({ title, project, architecture, onClose }: BomModalProps) => {
  const { value: interactiveBomEnabled } = useFeatureFlag("interactive_bom");

  if (interactiveBomEnabled) {
    return <InteractiveBomModal project={project} architecture={architecture} onClose={onClose} />;
  }

  return <BomModal title={title} project={project} architecture={architecture} onClose={onClose} />;
};

export default BomModalSwitch;
